import {
  ALBUM_SUBTYPE,
  ALBUM_TYPE,
} from '../../../../../../../../constants/albums';

const socialPrintTemplateStrings = {
  [ALBUM_TYPE.PRO]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR photos and delivers them to your phone!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite photos from our web gallery!',
  },
  [ALBUM_SUBTYPE.CAMPS]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR camper’s photos and delivers them to your phone!!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR camper’s photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite photos from camp!',
  },
  [ALBUM_SUBTYPE.SCHOOLS]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR student’s photos and delivers them to your phone!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR student’s photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite photos from school!',
  },
  [ALBUM_SUBTYPE.GREEK]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR chapter photos and delivers them to your phone!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR chapter photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite chapter photos from our web gallery!',
  },
  [ALBUM_SUBTYPE.SPORTS]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR athlete’s photos and delivers them to your phone!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR athlete’s photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite action shots from our web gallery!',
  },
  [ALBUM_SUBTYPE.CHURCH]: {
    photoFinderMainCopy:
      'Waldo uses facial recognition to find YOUR photos and delivers them to your phone!',
    parentPayMainCopy:
      'Waldo uses facial recognition to find YOUR photos and delivers them to your phone!',
    socialSellPhotosMainCopy:
      'Get your photo proofs texted to you and purchase them directly from your mobile device!',
    webGalleryMainCopy:
      'View, download, and share all your favorite photos from our web gallery!',
  },
};

export default socialPrintTemplateStrings;
